// create a new page for Company Settings - E-105
import {
  Grid,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  Typography,
  Switch,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
} from "@material-ui/core";
import * as React from "react";
import { observable, action } from "mobx";
import { createStyles, withStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import { Loading } from "src/components/loading";
import { withRouter } from "react-router";
import { validationsStore } from "../../../../validations";
import { companiesAdminStore } from "..";
import InputAdornment from '@material-ui/core/InputAdornment'; // E-105 new

const styles = createStyles({
  root: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    // padding: "1.5rem",
    padding: "5px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  rowContainer: {
    width: "100%",
    display: "flex",
    alignContent: "center",
    margin: "0 auto",
    // padding: "3rem",
  },
  columnContainer: {
    width: "100%",
    display: "flex",
    margin: "0 auto",
    // padding: "3rem",
  },
  textField: {
    display: "flex",
    paddingRight: "24px",
  },
  roleSelect: {
    minWidth: "9rem",
  },
  companySelect: {
    minWidth: "16.5rem",
  },
  appRoleSelect: {
    minWidth: "16.5rem",
    paddingTop: "1.5rem",
  },
  formContainer: {
    width: "100%",
    padding: "1.5rem",
  },
  submitContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
  },
  submitButton: {
    backgroundColor: "#2A2A55",
    border: "1px solid #2D4D73",
    color: "#FAFAFA",
  },
  tabRoot: {
    height: "100%",
  },
});

// C-108
const PurpleSwitch = withStyles({
  switchBase: {
    // color: 'green',
    '&$checked': {
      color: '#3D9970',
    },
    '&$bar': {
      color: '#7FDBFF',
    },
  },
  checked: {},
})(Switch);

@observer
class CompaniesSettings extends React.Component<any> {

  @observable public dialogOpen: boolean = false;// E-105 new
  @observable public tempDropValue: string = "";// E-105 new
  @observable public tempMinTransactionFee: string = "";// E-105 new
  @observable public dialogDeterminationSelection: boolean = false;// E-105 new
  @observable public debounceTimer: ReturnType<typeof setTimeout> | null = null; // E-105 new

  // E-105 new
  public customDebounce(callback: (value: string) => void, delay: number, value: string) {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      callback(value);
    }, delay);
  }

  // E-105 new
  public componentDidMount = async () => {
    this.tempDropValue = this.props?.currentCompany?.claimApprovalDetermination;
    this.tempMinTransactionFee = this.props?.currentCompany?.CompanyMinTransactionFee;
    validationsStore.runValidator("CompanyMinTransactionFee", 10);    
  };

  public componentDidUpdate() {
   if(this.props?.currentCompany?.CompanyMinTransactionFee?.length ===0){
    validationsStore.runValidator("CompanyMinTransactionFee", 10);
   }
  }

  public handleBlur = (field: string) => (event: React.FocusEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value === "") return;

    const numberValue = parseFloat(value);
    const formatted = isNaN(numberValue) ? "" : numberValue.toFixed(2);

    if (field === "CompanyMinTransactionFee" && this.props.match.params.view_type === "edit") {
      if (formatted !== this.tempMinTransactionFee) {
        this.dialogOpen = true;
      } else {
        this.dialogOpen = false;
      }
    }

    if (formatted) this.props.currentCompany.isTransactionFeeUpdated = 0;
    this.props.currentCompany.CompanyMinTransactionFee = formatted;
  };

  //E-105 new
  public getSiteInfo = (item: any) => {
    const site = companiesAdminStore?.all_sites.filter((s: any, i: number) => s.site_id === item)[0];
    if (!site) return "none";
    return <div>{site.displayName} - <span>${site.siteMinTransactionFee}</span></div>;
  };

  public getDeterminationSelectDialog = (active: boolean, item: any) => {
    return (
      <Dialog
        open={active}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      // onBackdropClick={() =>this.dialogOpen = false}
      >
        <DialogTitle style={{ backgroundColor: '#2a2a55', padding: 10 }}>
          <h3 style={{ color: 'white', justifySelf: 'center' }}> ⚠️ Warning</h3>
        </DialogTitle>
        <DialogTitle>
          <span style={{ fontWeight: 'bold' }}>Updating Claim Approval Determination</span>
        </DialogTitle>
        <DialogContent >
          Updating the Claim Approval Determination from{' '}
          <h3 style={{color:'black', display:'contents'}}>'{this.tempDropValue === "netProfit" ? "Net Profit" : "Gross Profit"}'</h3>{' '}
          to{' '}
          <h3 style={{color:'black', display:'contents'}}>'{this.props?.currentCompany?.claimApprovalDetermination === "netProfit" ? "Net Profit" : "Gross Profit"}'</h3>, will disable the current transaction value of{' '}
          <h3 style={{color:'red', display:'contents'}}>${this.props?.currentCompany?.CompanyMinTransactionFee}</h3>, for ALL assigned Pharmacies related to this Company.
        </DialogContent>
        <DialogTitle style={{ padding: 0 }}>
          <h3 style={{ color: 'red', justifySelf: 'center' }}> Are you sure you want to make these changes?</h3>
        </DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            classes={{ root: this.props.classes.submitButton }}
            // tslint:disable-next-line: jsx-no-lambda
            onClick={() => {
              this.props?.currentCompany?.claimApprovalDetermination = this.tempDropValue
              this.dialogDeterminationSelection = false
            }}
            color="primary"
            autoFocus={true}
          >
            No
          </Button>
          <Button
            variant="contained"
            classes={{ root: this.props.classes.submitButton }}
            // tslint:disable-next-line: jsx-no-lambda
            onClick={() => this.dialogDeterminationSelection = false}
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  // E-105 new
  public getAlertDialogHere = (active: boolean, item: any) => {
    return (
      <Dialog
        open={active}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      // onBackdropClick={() =>this.dialogOpen = false}
      >
        <DialogTitle style={{ backgroundColor: '#2a2a55', padding: 10 }}>
          <h3 style={{ color: 'white', justifySelf: 'center' }}> ⚠️ Warning</h3>
        </DialogTitle>
        <DialogTitle>
          <span style={{ fontWeight: 'bold' }}>Updating Claim Approval Determination</span>
        </DialogTitle>
        <DialogContent >
          If you updating the Minimum Transaction Fee, will Change the current transaction value of <h3 style={{ color: 'red', display: 'contents' }}>${this.props.currentCompany.CompanyMinTransactionFee}</h3>, for ALL assigned <h3 style={{ color: 'black', display: 'contents' }}> Company pharmacies </h3>.
          <div style={{ backgroundColor: '#f7e3c5', padding: '10px 14px 24px 20px', marginTop: 15, margin: '12px' }}>
            {
              companiesAdminStore?.all_sites &&
              item.currentCompany?.CompanySiteList
                .map((site: any) => {
                  const fullSite = companiesAdminStore.all_sites.find((s: any) => s.site_id === site.site_id);
                  return {
                    ...site,
                    displayName: fullSite?.displayName || '',
                    CompanyMinTransactionFee: fullSite?.CompanyMinTransactionFee,
                  };
                })
                .filter((site: any) => {
                  if (site.siteClaimApprovalDetermination === "grossProfit") {
                    return site.siteClaimApprovalDetermination !== this.props.currentCompany?.claimApprovalDetermination
                  }
                  if (site.isTransactionFeeUpdated === 1 && site.live == 1) {
                    return site.siteMinTransactionFee !== this.props.currentCompany.CompanyMinTransactionFee;
                  }
                })
                .sort((a: any, b: any) => a.displayName.localeCompare(b.displayName))
                .map((site: any, index: number) => (
                  <div key={site.site_id} style={{ display: 'flex' }}>
                    {index + 1}. {this.getSiteInfo(site.site_id)}
                  </div>
                ))
            }
          </div>
        </DialogContent>
        <DialogTitle style={{ padding: 0 }}>
          <h3 style={{ color: 'red', justifySelf: 'center' }}> Are you sure you want to make these changes?</h3>
        </DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            classes={{ root: this.props.classes.submitButton }}
            // tslint:disable-next-line: jsx-no-lambda
            onClick={() => {
              this.props?.currentCompany?.CompanyMinTransactionFee = this.tempMinTransactionFee
              this.dialogOpen = false
            }}
            color="primary"
            autoFocus={true}
          >
            No
          </Button>
          <Button
            variant="contained"
            classes={{ root: this.props.classes.submitButton }}
            // tslint:disable-next-line: jsx-no-lambda
            onClick={() => this.dialogOpen = false}
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  public render() {
    const { classes, mode, currentCompany } = this.props;

    let claimApprovalDeterminationOption: any = [
      { label: "Gross Profit - (Consider without Copay Amount)", value: "grossProfit" },
      { label: "Net Profit - (Consider with Copay Amount)", value: "netProfit" },
    ];

    const alertDialogHere = this.getAlertDialogHere(this.dialogOpen, this.props);  // E-105 new   
    const determinationSelectDialog = this.getDeterminationSelectDialog(this.dialogDeterminationSelection, this.props);  // E-105 new   

    // E-105 new
    let popCondition = currentCompany?.CompanySiteList
      .map((site: any) => {
        const fullSite = companiesAdminStore?.all_sites.find((s: any) => s.site_id === site.site_id);
        return {
          ...site,
          displayName: fullSite?.displayName || '',
          CompanyMinTransactionFee: fullSite?.CompanyMinTransactionFee,
        };
      })
      .filter((site: any) => {
        if (site.siteClaimApprovalDetermination === "grossProfit") {
          return site.siteClaimApprovalDetermination !== this.props.currentCompany?.claimApprovalDetermination
        }
        if (site.isTransactionFeeUpdated === 1 && site.live == 1) {
          return site.siteMinTransactionFee !== this.props.currentCompany?.CompanyMinTransactionFee;
        }
      })

    if (!this.props.currentCompany) {
      return <Loading />;
    } else {
      return (
        <div className={classes.root}>
          {(validationsStore.validator["CompanyMinTransactionFee"].valid && this.dialogOpen && !this.dialogDeterminationSelection && popCondition.length !== 0) ? alertDialogHere : false}
          {(this.dialogDeterminationSelection && !this.dialogOpen) ? determinationSelectDialog : false}
          <Grid container={true} spacing={8}>
            <Grid item={true} xs={4}>
              <Typography variant="h5">Genernal Settings</Typography>
              {/* <div className={classes.toggleBtn}>
                <span>Copay Collection Required to Dispense</span>
                <PurpleSwitch
                  checked={this.props.currentCompany.allowCompanyCopayCollection === 1}
                  // tslint:disable-next-line: jsx-no-lambda
                  onChange={() => this.toggleAllowCopayCollection()}
                  // value='blah'
                  color="secondary"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              </div> */}
              <div className={classes.toggleBtn}>
                <span>Skip e-sign required to dispense</span>
                <PurpleSwitch
                  checked={this.props.currentCompany.allowUsersForEsign === 1}
                  // tslint:disable-next-line: jsx-no-lambda
                  onChange={() => this.toggleAllowEsing()}
                  // value='blah'
                  color="secondary"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              </div>
            </Grid>

            {/* D-023 E-053.1 */}
            <Grid item={true} xs={4}>
              <Typography variant="h5">Email Settings</Typography>
              <TextField
                label="Order Approval Email"
                classes={{ root: classes.textField }}
                value={this.props.currentCompany.CompanyApprovalOrderEmail}
                InputLabelProps={{ shrink: true }}
                onChange={this.CompanyApprovalOrderEmailFunc()}
                disabled={this.props.match.params.view_type === "detail"}
              />
            </Grid>
            <Grid item={true} xs={4}>
              <Typography variant="h5">Financial Settings</Typography>
              <div style={{ display: "grid", marginBottom: 10 }}>
                <InputLabel htmlFor={"portal_role"} shrink={true} >
                  Claim Approval Determination
                </InputLabel>
                <Select
                  inputProps={{ shrink: true }}
                  value={this.props?.currentCompany?.claimApprovalDetermination} // E-105 new
                  classes={{ root: classes.companySelect }} //D-011
                  // tslint:disable-next-line: jsx-no-lambda
                  onChange={this.claimApprovalDetFun() && this.handleInput("claimApprovalDetermination")}
                  disabled={this.props.match.params.view_type === "detail"}
                >
                  {claimApprovalDeterminationOption?.map((item: any, index: number) => (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <TextField
                label="Minimum Transaction Fee"  // E-105 new
                classes={{ root: classes.textField }}
                value={this.props.currentCompany.CompanyMinTransactionFee}
                InputLabelProps={{ shrink: true }}
                placeholder={"0.01"} // E-105 new
                onChange={this.handleInput("CompanyMinTransactionFee")}
                onBlur={this.handleBlur("CompanyMinTransactionFee")}
                error={!validationsStore.validator["CompanyMinTransactionFee"].valid}
                helperText={!validationsStore.validator["CompanyMinTransactionFee"].valid
                  ? validationsStore.validator["CompanyMinTransactionFee"].errorMessage.join()
                  : " "
                }
                disabled={this.props.match.params.view_type === "detail"}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}  // E-105 new
              />

            </Grid>
            <Grid item={true} xs={4}></Grid>
            <Grid item={true} xs={4} />
          </Grid>
        </div>
      );
    }
  }
  @action
  protected handleInput = (property: string) => (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const value = e.target.value;

    if (property === "claimApprovalDetermination" && this.props.match.params.view_type === "edit") {
      if (
        value === this.tempDropValue &&
        value === this.props.currentCompany?.claimApprovalDetermination
      ) {
        this.dialogDeterminationSelection = false;
      }
      else if (value === "grossProfit" || value === "netProfit") {
        this.dialogDeterminationSelection = true;
      }
      else {
        this.dialogDeterminationSelection = false;
      }
    }

    if (property === "CompanyMinTransactionFee" && this.props.match.params.view_type === "edit") {
      this.customDebounce((v) => {
        if (v !== this.tempMinTransactionFee) {
          this.dialogOpen = true;
        } else {
          this.dialogOpen = false;
        }
      }, 800, value);
    }

    this.props.currentCompany[property] = value;
    validationsStore.runValidator(property, value);
  };


  @action
  public toggleAllowEsing = () => {
    const val = this.props.currentCompany.allowUsersForEsign === 0 ? 1 : 0;
    this.props.currentCompany.allowUsersForEsign = val;
  }

  @action
  protected claimApprovalDetFun =
    () => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      this.props.currentCompany.claimApprovalDetermination = e.target.value;
    };

  @action
  protected CompanyApprovalOrderEmailFunc =
    () => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      this.props.currentCompany.CompanyApprovalOrderEmail = e.target.value;
    };

  // @action //D-002.8
  // public toggleAllowCopayCollection = () => {
  //   const val = this.props.currentCompany.allowCompanyCopayCollection === 0 ? 1 : 0;
  //   this.props.currentCompany.allowCompanyCopayCollection = val;
  // }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(CompaniesSettings)
);



// WEBPACK FOOTER //
// ./src/modules/admin/modules/CompaniesAdmin/components/CompaniesSettings.tsx